import { deeplyTransformEmptyStringToUndefined } from "utilities";
import { Route as AppRoute } from "utilities/app-routes";
import { formatTouchpointClassesForApi } from "components/modals/creative-modal/creative-modal-utils";

import { AddTouchpointFormData } from "components/modals/creative-modal/creative-modal-types";

import type {
  TouchpointCreateRequest,
  TouchpointCreateRequestContentType,
  TouchpointCreateRequestPopulationType,
  TouchpointVersionCreateRequest,
} from "generated/schemas";
import { TouchpointCreateRequestType } from "generated/schemas";

type CreateTouchpointFn = (args: {
  data: TouchpointCreateRequest;
  versionData: TouchpointVersionCreateRequest;
}) => Promise<{ touchpoint: { id: string }; version?: { id: string } }>;

type SubmitCreateBlankTouchpointParams = {
  data: AddTouchpointFormData;
  clientId: string;
  campaignId: string;
  createTouchpoint: CreateTouchpointFn;
};

export const submitCreateBlankTouchpoint = async ({
  data,
  clientId,
  campaignId,
  createTouchpoint,
}: SubmitCreateBlankTouchpointParams): Promise<string> => {
  const touchpointAttributes = deeplyTransformEmptyStringToUndefined({
    name: data.name,
    contentType: data.contentType,
  });

  const payload: TouchpointCreateRequest = {
    name: touchpointAttributes.name || "",
    type: data.type ?? TouchpointCreateRequestType.LANDING_PAGE,
    contentType: touchpointAttributes.contentType as TouchpointCreateRequestContentType,
    populationType: data.populationType as TouchpointCreateRequestPopulationType,
    folderId: data.folderId,
    copyCode: data.copyCode,
    insightsActivator: data.insightsActivator,
    classes: formatTouchpointClassesForApi(data.classes),
  };
  const versionPayload: TouchpointVersionCreateRequest = {
    description: "Initial draft",
    applyClientTheme: false,
    fiscalYear: data.fiscalYear,
  };
  const { touchpoint, version } = await createTouchpoint({
    data: payload,
    versionData: versionPayload,
  });
  if (!version) throw new Error("Touchpoint version was not created");
  return `/clients/${clientId}/campaigns/${campaignId}/creative/${touchpoint.id}/${AppRoute.versions}/${version.id}/${AppRoute.lpBuilder}`;
};
